import { useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from './SharedLibrary.module.css';

import { useAppDispatch, useAppSelector } from '../../hooks/useRedux';
import { usePage } from '../../hooks/usePage';
import useModal from '../../hooks/useModal';

import { menuChanged, selectMenu } from '../../features/infoSlice';
import {
  selectShareOptions,
  shareLinkNotiSet,
} from '../../features/shareSlice';

import { useGetSharedLinksQuery } from '../../services/share';

import Container from '../../components/Container';
import TopArea from '../../components/TopArea';
import ListOption from '../../components/ListOption';
import List from '../../components/List';
import Details from '../../components/Details';
import { LIST, SHARED_LIBRARY } from '../../constants';

export default function SharedLibrary() {
  const cx = classNames.bind(styles);
  const dispatch = useAppDispatch();
  const menu = useAppSelector(selectMenu);
  const options = useAppSelector(selectShareOptions);
  const { isDetailsOpened, isEditMode } = options;
  const { pageChanged } = usePage();
  const { toggleModal } = useModal();

  const { data, isLoading } = useGetSharedLinksQuery();

  const toggleLinkNotiModal = () => {
    dispatch(shareLinkNotiSet(data));
    toggleModal({
      name: 'link-notification',
      id: 'linkNotification',
      type: 'alert',
      isOpen: !!data?.length,
    });
  };

  useEffect(() => {
    dispatch(menuChanged('share'));
    menu === 'share' && dispatch(pageChanged(0));
    toggleLinkNotiModal();
  }, [data]);

  if (menu !== 'share' || isLoading) return null;

  return (
    <Container isSubPage={true}>
      <TopArea title={SHARED_LIBRARY} className="st_subpage" />
      <div className={cx('content')}>
        <div className={cx('section')}>
          <h2 className="blind">
            {SHARED_LIBRARY} {LIST}
          </h2>
          <ListOption />
          <div
            className={cx(
              'library_area',
              {
                'library--info-active': isDetailsOpened,
              },
              {
                'is--editing': isEditMode,
              }
            )}
          >
            <List />
            {isDetailsOpened && <Details />}
          </div>
        </div>
      </div>
    </Container>
  );
}
